import { render } from "./modal-update-order.vue?vue&type=template&id=5d89bf8c&scoped=true&ts=true"
import script from "./modal-update-order.vue?vue&type=script&lang=ts"
export * from "./modal-update-order.vue?vue&type=script&lang=ts"

import "./modal-update-order.vue?vue&type=style&index=0&id=5d89bf8c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d89bf8c"]])

export default __exports__